// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"500b765a","445":"e56cdc19","453":"d855a71b","590":"83a266af","621":"4ddf19d4","776":"5b00f3c0","922":"2810273e"}[chunkId] + ".chunk.js";
};